import React, { useState, useEffect, useCallback } from 'react';
import './App.css';

const WIKIPEDIA_RANDOM_URL = "https://zh.wikipedia.org/api/rest_v1/page/random/summary";

function App() {
  const [entry, setEntry] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    // Also check for user's system preference
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return savedTheme || (prefersDark ? 'dark' : 'light');
  });

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  const fetchRandomEntry = useCallback(async () => {
    setLoading(true);
    setError(null);
    setEntry(null);
    try {
      const response = await fetch(WIKIPEDIA_RANDOM_URL, {
        headers: {
          'Accept': 'application/json',
          'Accept-Language': 'zh-cn'
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setEntry({
        title: data.title,
        summary: data.extract,
        url: data.content_urls.desktop.page
      });
    } catch (e) {
      setError('无法获取维基词条。请稍后重试。');
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRandomEntry();
  }, [fetchRandomEntry]);

  return (
    <div className="container">
      <div className="header-controls">
        <div className="title-container">
          <img src="/logo.svg" className="app-logo" alt="logo" />
          <h1>随机维基词条</h1>
        </div>
        <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle theme">
          {theme === 'light' ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
          )}
        </button>
      </div>
      <button onClick={fetchRandomEntry} disabled={loading}>
        {loading ? '加载中...' : '获取新词条'}
      </button>
      <div className="wiki-entry">
        {loading && <p>正在加载...</p>}
        {error && <p className="error">{error}</p>}
        {entry && (
          <>
            <h2>{entry.title}</h2>
            <p>{entry.summary}</p>
            <a href={entry.url} target="_blank" rel="noopener noreferrer">
              在维基百科上阅读更多
            </a>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
